module.exports = __webpack_public_path__ + "h5/img/3.7768c4a1.png";